const ContractCreateView = () => import("@views/contract-create/contract-create-view.vue");
const PrecheckView = () => import("@app/views/contract-create/precheck-view.vue");
const ContractInfoView = () => import("@/app/views/contract-create/contract-info-view.vue");
const InstallmentPlanSelectionView = () => import("@/app/views/contract-create/installment-plan-selection.view.vue");
const PurchaseIdentificationInfoView = () => import("@/app/views/contract-create/purchase-identification-info-view.vue");
const ContractEndFailView = () => import("@/app/views/contract-create/contract-end-fail-view.vue");
const ContractEndSuccessView = () => import("@/app/views/contract-create/contract-end-success-view.vue");
import suspectPerson from '@app/assets/images/components/icon-btn-sumljiva-oseba.svg';
import { RouteLocationNormalizedLoaded } from 'vue-router';

export const contractCreateRoutes = [
    {
        component: ContractCreateView,
        name: "contractCreate_home",
        path: "contract-create",
        redirect: { name: "Precheck" },
        beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
            if(from.name == undefined){
                return { name: "dashboard_dashboard" };
            }
            else{
                window.onbeforeunload = () => {
                    return confirm();
                }
            }
        },
        children: [ 
            {
                component: PrecheckView,
                name: "Precheck",
                path: "precheck",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "executePrecheck", visible: true }
                    ],
                    navigation: { nextStep: "PurchaseIdentificationInfo", endFail: "EndFail" },
                },
            },
            {
                component: PurchaseIdentificationInfoView,
                name: "PurchaseIdentificationInfo",
                path: "purchase-identification-info",
                props: true,
                meta: {
                    buttons: [
                        { name: "DIYMobileNext", action: "validatecustomer", visible: true },
                        { name: "SignVloga", action: "validate", visible: true },
                    ],
                    icons: [
                        { image: suspectPerson, name: "suspectPerson", class: "btn btn--primary-outline btn--round", action: "suspectPerson", visible: true }
                    ],
                    navigation: { nextStep: "InstallmentPlan", endFail: "EndFail", endSuccess: "EndSuccess" },
                },
            },
            {
                component: InstallmentPlanSelectionView,
                name: "InstallmentPlan",
                path: "installment-plan",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "calculationAndExposure", visible: true },
                    ],
                    navigation: { nextStep: "ContractInfo", endFail: "EndFail" },
                },
            },
            {
                component: ContractInfoView,
                name: "ContractInfo",
                path: "contract-info",
                props: true,
                meta: {
                    buttons: [
                        { name: "SignContract", action: "createContract", visible: true },
                    ],
                    navigation: { endFail: "EndFail", endSuccess: "EndSuccess" },
                },
            },
            {
                component: ContractEndFailView,
                name: "EndFail",
                path: "end-fail",
                props: true,
                meta: {
                    buttons: [
                        { name: "ToContractList", navigateTo: "goContractList", visible: true },
                    ],
                    navigation: { goContractList: "seznam_pogodb_home" },
                },
            },
            {
                component: ContractEndSuccessView,
                name: "EndSuccess", 
                path: "end-success",
                props: true,
                meta: {
                    buttons: [
                        { name: "ToContractList", navigateTo: "goContractList", visible: true },
                    ],
                    navigation: { goContractList: "seznam_pogodb_home" },
                },
            },
           
        ]
    },
];